import {
    FETCH_DELETE_ACTOR_TYPES_REQUEST,
    FETCH_DELETE_ACTOR_TYPES_SUCCESS,
    FETCH_DELETE_ACTOR_TYPES_FAILURE,
} from '../../actions/actorTypes/delete-actorTypes-action';

const initialState = {
    removed: null,
    isLoading: false,
    error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const DeleteActorTypeReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_DELETE_ACTOR_TYPES_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_DELETE_ACTOR_TYPES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                removed: action.payload || true,
            };
        case FETCH_DELETE_ACTOR_TYPES_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_DATA:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default DeleteActorTypeReducer;